import CustomDropDown from '@/utils/customDropDown';
import {
  Box,
  Button,
  HStack,
  Image,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { useRef } from 'react';

export default function Filters({
    children,
    title,
    customClass,
  }: {
    children: React.ReactNode,
    title: string,
    customClass?: string,
  }) {
    const filterButtonRef = useRef<HTMLDivElement>(null);
    const {
        isOpen: isFilterOpen,
        onOpen: onFilterOpen,
        onClose: onFilterClose
      } = useDisclosure();
    const handleClickOutside = (event: any) => {
      if (
        filterButtonRef.current &&
        !filterButtonRef.current.contains(event.target)
      ) {
        onFilterClose();
      }
    };
  
    return (
      <>
        <Box
         className={
              'filter-dropdown-box'
         }
         ref={filterButtonRef}
        >
          <HStack
            onClick={isFilterOpen ? onFilterClose : onFilterOpen}
            cursor={'pointer'}
            className="custom-dropdown-button-wrapper"
          >
            <Box className="custom-dropdown-triangle" right={'50%'}></Box>
            <Button
              size={'sm'}
              backgroundColor={'#d7ebf9'}
              className="custom-dropdown-button"
            >
              <Image src={'/images/ui/filter.svg'}></Image>
            </Button>
            <Text fontSize={'18px'} lineHeight={'21.6px'}>
              {title}
            </Text>
          </HStack>
          {isFilterOpen && (
            <CustomDropDown
              children={children}
              handleClickOutside={handleClickOutside}
              className={
              `dealer-filters-dropdown ${customClass ? customClass : ''}`
              }
            />
          )}
        </Box>
      </>
    );
  }
  